import React from "react";
import styled from "styled-components";
import * as Popover from "@radix-ui/react-popover";
import { ScrollbarStyles } from "@themes/ScrollbarStyles";
import Styles from "@themes/Styles";
import CloseIcon from "/resources/icons/CloseIcon.svg";

/* ------------------------------------------------------------- */
/* ---------------- PopupMenuComponents.Trigger ---------------- */
/* ------------------------------------------------------------- */

const StyledPopupMenuTrigger = styled(Popover.Trigger)`
    all: unset;
`;

/* ------------------------------------------------------------- */
/* -------------- PopupMenuComponents.Content ------------------ */
/* ------------------------------------------------------------- */
/* - Note: this component must be used with -------------------- */
/* - PopupMenuComponents.Root & PopupMenuComponents.Trigger ---  */
/* ------------------------------------------------------------- */

const StyledPopupMenuContent = styled(Popover.Content)`
    padding: unset;
    border-radius: ${Styles.borderRadiusSharp};
    background-color: ${(props) => props.theme.backgroundPrimary};

    width: fit-content;
    box-shadow: ${(props) => props.theme.boxShadow} ${(props) => props.theme.boxShadowColor};

    &:focus {
        outline: unset;
    }

    max-height: var(--radix-popover-content-available-height);
    overflow-y: auto;

    ${ScrollbarStyles};
`;
interface PopupMenuContentProps {
    readonly children: React.ReactNode[] | React.ReactNode;
}
export function PopupMenuContent(props: PopupMenuContentProps) {
    const portalDiv = document.getElementById("dropdown-portal");

    return (
        <Popover.Portal container={portalDiv}>
            <StyledPopupMenuContent>{props.children}</StyledPopupMenuContent>
        </Popover.Portal>
    );
}

/* -------------------------------------------------------------------- */
/* --------------- PopupMenuComponents.CloseButton -------------------- */
/* - Note: using the Popover.Close is the only way to close the popover */
/* - To close the popover on another button click, wrap that button ----*/
/* - in the PopupMenuCloseButtonWrapper component --------------------- */
/* -------------------------------------------------------------------- */
export const PopupMenuCloseButtonWrapper = styled(Popover.Close)`
    all: unset;
    cursor: pointer;
`;

const StyledCloseIcon = styled(CloseIcon)`
    fill: ${(props) => props.theme.iconColor};
`;

interface PopupMenuCloseButtonProps {}
export function PopupMenuCloseButton(props: PopupMenuCloseButtonProps) {
    return (
        <PopupMenuCloseButtonWrapper aria-label="Close">
            <StyledCloseIcon />
        </PopupMenuCloseButtonWrapper>
    );
}

export const PopUpMenuComponents = {
    Root: Popover.Root,
    Trigger: StyledPopupMenuTrigger,
    Content: PopupMenuContent,
    CloseButton: PopupMenuCloseButton,
};
